module.exports = __webpack_public_path__ + "static/index-558d3d48cf48d4502bb68d9ce36a9827.png";